module.exports = __webpack_public_path__ + "static/media/finpay_mini.bf22f3d8.png";